import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useSuppliersList() {
  // Use toast
  const toast = useToast();

  const refSupplierListTable = ref(null);

  //Filter
  const companyFilter = ref(1);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "ID", sortable: true },
    { key: "total_coins", label: "貨幣餘額", sortable: true } /* 
    { key: "uploadrate", label: "上傳率", sortable: true }, */,
    { key: "total_points", label: "積分", sortable: true },
    { key: "coin_records", label: "交易記錄" },
    {
      key: "company_name_cn",
      stickyColumn: true,
      label: "財務名稱(中文) ",
      sortable: true,
    },
    { key: "company_name_en", label: "財務名稱(英文) ", sortable: true },
    { key: "ci_number", label: "公司註冊證書號碼(CI)", sortable: true },
    { key: "address", label: "地址" },
    { key: "contact_name", label: "聯絡人姓名", sortable: true },
    { key: "contact_phone", label: "聯絡人電話" },
    { key: "childs", label: "旗下帳戶" },
    { key: "is_member", label: "會員", sortable: true },
    { key: "membership_expiry_date", label: "會員到期日", sortable: true },
    { key: "moneylender_license_expiry_date", label: "放債人牌照到期日", sortable: true },
    { key: "search_limit", label: "剩餘搜尋次數", sortable: true },
    {
      key: "need_sign_member_contract",
      label: "需要簽署會員合約",
      sortable: true,
    },
    {
      key: "can_view_report_directly",
      label: "可直接查看報告",
      sortable: true,
    },
    { key: "is_active", label: "狀態" },
    { key: "actions", label: "操作" },
    // { key: "mobile", label: "手提電話" },
    // { key: "email", label: "電郵地址" },
    // { key: "moneylender_number", label: "放債人號碼", sortable: true },
  ];
  const perPage = ref(10);
  const totalSuppliers = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);
  const suppliersList = ref([]);

  const dataMeta = computed(() => {
    const localItemsCount = refSupplierListTable.value
      ? refSupplierListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSuppliers.value,
    };
  });

  const refetchData = () => {
    refSupplierListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, companyFilter], () => {
    refetchData();
  });

  const fetchSuppliers = (ctx, callback) => {
    store
      .dispatch("app-supplier/fetchSuppliers", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        company_bit: companyFilter.value,
      })
      .then((response) => {
        const { suppliers, total } = response.data;
        callback(suppliers);
        suppliersList.value = suppliers;
        totalSuppliers.value = total;
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching supplier list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const companyOptions = [
    { id: 1, name: "公司" },
    { id: 0, name: "街客" },
    { id: null, name: "全部" },
  ];

  // 檢查會員是否過期的函數
  const isMembershipExpired = (membershipExpiryDate) => {
    if (!membershipExpiryDate) return false;

    const today = new Date();
    const expiryDate = new Date(membershipExpiryDate);

    // 比較日期，如果當前日期大於會員到期日，則會員已過期
    return today > expiryDate;
  };

  // 檢查放債人牌照是否過期的函數
  const isMoneylenderLicenseExpired = (licenseExpiryDate) => {
    if (!licenseExpiryDate) return false;

    const today = new Date();
    const expiryDate = new Date(licenseExpiryDate);

    // 比較日期，如果當前日期大於放債人牌照到期日，則牌照已過期
    return today > expiryDate;
  };

  return {
    fetchSuppliers,
    tableColumns,
    perPage,
    currentPage,
    totalSuppliers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSupplierListTable,
    ability,
    suppliersList,
    refetchData,
    companyFilter,
    companyOptions,
    isMembershipExpired,
    isMoneylenderLicenseExpired,
  };
}
